import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-flex',
	templateUrl: './icon-flex.component.svg',
})
export class IconFlexComponent {}
